// extracted by mini-css-extract-plugin
export default {"aglmd-error-fallback__title":"cjU4Ps9WFtWSyeKw8HYj"};